import React, {useEffect} from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch, useNeuroState } from './state';
import { checkIfEmployeeIsLoggedIn } from '../neuro-guide/guide-framework/state/Login/LoginActions';
import { useGuideConfig } from './hooks/useGuideConfig';

const NeuroRoot = ({ AppComponent, LoadingComponent, isLoading }) => {
  const { isBranchGuide } = useGuideConfig();
  const dispatch = useDispatch();
  const { employeeLoginState } = useNeuroState();
  useEffect(() => {
    isBranchGuide && dispatch(checkIfEmployeeIsLoggedIn());
  }, [employeeLoginState?.loginFlowEnabled, isBranchGuide]);

  return <Router>{isLoading || (isBranchGuide && employeeLoginState === undefined) ? <LoadingComponent /> : <AppComponent />}</Router>;
};

NeuroRoot.propTypes = {
  AppComponent: PropTypes.any,
  isLoading: PropTypes.bool,
  LoadingComponent: PropTypes.any,
};

NeuroRoot.displayName = 'NeuroRoot';

export default NeuroRoot;
